import { z } from 'zod';
export const PaginationInput = z.object({
    page: z.number().int().min(1).default(1),
    pageSize: z.number().int().min(1).max(200).default(50),
});
export const PaginatedResult = (item) => z.object({
    items: z.array(item),
    totalCount: z.number().int().nonnegative(),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1),
});
/**
 * Keyset (cursor) pagination input — spread into a channel's message-list
 * schema. Newer-first windowing: `cursor` is the id of the oldest row already
 * loaded (exclusive); omit it for the first/newest page. O(limit) at any depth,
 * unlike OFFSET `skip/take`. Used by the chat timeline + FB/IG inbox threads.
 */
export const CursorPageInput = z.object({
    cursor: z.number().int().positive().optional(),
    limit: z.number().int().min(1).max(100).default(30),
});
